// extracted by mini-css-extract-plugin
export default {"ttp-switch":"Switch_ttp-switch__9tKLZ"};